module.exports = __webpack_public_path__ + "static/img/seckill_banner.1db7ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/seckill_banner.png
// module id = wTqp
// module chunks = 1